import { render, staticRenderFns } from "./ChooseVoucher.vue?vue&type=template&id=0b5af032&scoped=true"
import script from "./ChooseVoucher.vue?vue&type=script&lang=js"
export * from "./ChooseVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5af032",
  null
  
)

export default component.exports